// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import ChapterToggleController from "./chapter_toggle_controller"
application.register("chapter-toggle", ChapterToggleController)

import CloseToggleController from "./close_toggle_controller"
application.register("close-toggle", CloseToggleController)

import DbController from "./db_controller"
application.register("db", DbController)

import DismissController from "./dismiss_controller"
application.register("dismiss", DismissController)

import DropdownFilterController from "./dropdown_filter_controller"
application.register("dropdown-filter", DropdownFilterController)

import FroalaController from "./froala_controller"
application.register("froala", FroalaController)

import ImageClickController from "./image_click_controller"
application.register("image-click", ImageClickController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ModalCleanupController from "./modal_cleanup_controller"
application.register("modal-cleanup", ModalCleanupController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultiselController from "./multisel_controller"
application.register("multisel", MultiselController)

import NewsReadController from "./news_read_controller"
application.register("news-read", NewsReadController)

import OpenasController from "./openas_controller"
application.register("openas", OpenasController)

import RemovalsController from "./removals_controller"
application.register("removals", RemovalsController)

import ScrollTopController from "./scroll_top_controller"
application.register("scroll-top", ScrollTopController)

import Select2modalController from "./select2modal_controller"
application.register("select2modal", Select2modalController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import TimeagoController from "./timeago_controller"
application.register("timeago", TimeagoController)

import SubscribeController from "./subscribe_controller"
application.register("subscribe", SubscribeController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import CustomFieldsController from "./custom_fields_controller"
application.register("custom-fields", CustomFieldsController)

import FieldTypeToggleController from "./field_type_toggle_controller"
application.register("field-type-toggle", FieldTypeToggleController)

import ResponseTemplateController from "./response_template_controller"
application.register("response-template", ResponseTemplateController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TwDropdownController from "./tw_dropdown_controller"
application.register("tw-dropdown", TwDropdownController)

import TwModalController from "./tw_modal_controller"
application.register("tw-modal", TwModalController)

import TwSidebarController from "./tw_sidebar_controller"
application.register("tw-sidebar", TwSidebarController)

import TwFroalaController from "./tw_froala_controller"
application.register("tw-froala", TwFroalaController)

import TwComposerController from "./tw_composer_controller"
application.register("tw-composer", TwComposerController)
